<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-7">
				<sf-card class="p-0 h-100 card_bg">
					<ro-apcn-search
						ref="roApcnSearch"
						:scrId="scrId"
						:pStartDt="pStartDt"
						:pEndDt="pEndDt"
						:pState1="pState1"
						:pState2="pState2"
						:pState3="pState3"
						:pState4="pState4"
						:pState5="pState5"
					/>
				</sf-card>
			</div>
			<div class="sf-col sf-col-17">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<ro-apcn-table
						ref="table"
						@PopupOpen="PopupOpen"
						@PopupPwaOpen="PopupPwaOpen"
						@registerRtnPart="registerRtnPart"
						@Refresh="Refresh"
						@CostUpShow="CostUpShow"
						:scrId="scrId"
					/>
					<erp-cost-upload-modal :scrId="scrId" ref="excelUploadPop"/>
				</sf-card>
			</div>
		</div>
		<!--엑셀 업로드 팝업창 영역 시작-->
		<ro-apcn-popup ref="roApcnPopup" @Refresh="Refresh" :scrId="scrId" />
		<pwa-apcn-popup ref="pwaApcnRegPopup" @Refresh="Refresh" :scrId="scrId" />
		<rtn-part-mst-popup ref="popup" :scrId="scrId" @Refresh="Refresh"></rtn-part-mst-popup>
		<!--엑셀 업로드 팝업창 영역 끝-->
	</div>
</template>

<script>
import ErpCostUploadModal from './Table/ErpCostUpload.vue';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../store/helpers';
import RoApcnSearch from './Search/RoApcnSearch.vue'; //RO신청현황 조회부분
import RoApcnTable from './Table/RoApcnTable.vue'; //RO신청현황 그리드 부분
import RoApcnPopup from './RoApcnPopup/RoApcnPopup.vue'; //RO 신청 현황 팝업부분
import PwaApcnPopup from '@mqy/ceqi/PwaApcn/Content/PwaApcnPopup/PwaApcnPopup.vue'; //PWA 신청현황팝업
import RtnPartMstPopup from '@mqy/ceqi/RtnPartMst/Content/Popup/RtnPartMstPopup.vue'; //고품분석팝업

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' }, //클레임 승인현황에서 날짜 검색조건 가져옴
		pState4: { type: String, default: '' }, //클레임 승인현황에서  가져옴
		pState5: { type: String, default: '' }, //클레임 승인현황에서 고품회수상태 가져옴
	},
	async created() {
		try {
			this.setState_({key: 'isMqyStation', value: await this.inclManyUsrGrp_(['MQYSS'])});
			// console.log('-----',this.isMqyStation);
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		} finally {
			this.$sf_toggleLoading(false);
		}
	},
	computed: {
		...qmsComputed,
		...rootComputed,
		...serviceComputed
	},
	components: { RoApcnSearch, RoApcnTable, RoApcnPopup, PwaApcnPopup, RtnPartMstPopup, ErpCostUploadModal },
	methods: {
		...qmsMethods,
		...rootMethods,
		...serviceMethods,
		CostUpShow(){
			console.log(this.$refs.excelUploadPop);
			this.$refs.excelUploadPop.open();
		},
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.roApcnSearch.searchList();
		},
		PopupOpen(param) {
			//console.log('ContentView 에서의 param값 ::::: ', param);

			this.$refs.roApcnPopup.open(param);
		},
		PopupPwaOpen(param) {
			//console.log('ContentView 에서의 param값 ::::: ', param);
			this.$refs.pwaApcnRegPopup.open(param);
		},
		registerRtnPart(param) {
			this.$refs.popup.open(param);
		} /*
		sendData(param) {
			alert('최종 팝업화면에서 가지고온 데이터 ::::: url 는 ' + param.url + ', title은 ' + param.title);
		}
		*/
	}
};
</script>

<style></style>
